import RestUtilities from './Base';

export default class Notification {
  static getSignin() {
    return RestUtilities.get(`/api/notification/list/signin`).then((response) => {
      return response
    })
  }

  static getDashboard() {
    return RestUtilities.get(`/api/notification/list/dashboard`).then((response) => {
      return response
    })
  }
}
